// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1>Amenity note</h1>
        </div>
        <div class="hoa-dialog__main">
            <p>{{ data.property.hoa.name || 'Your HOA' }} will receive this note regarding
                {{ data.cartItem.description || 'the amenity'}} after you complete the purchase.</p>
            <div [ngClass]="{ 'is-invalid': data.payerNotesError }" class="Field">
                    <textarea tid="amenityNoteText"
                              id="amenityNoteText"
                              class="Textarea"
                              [(ngModel)]="data.payerNotes"
                              (change)="data.changeFn(data)"
                              cols="30"
                              rows="5"
                              maxlength="250"
                              tid="comments">
                    </textarea>
                <span class="Field-error"
                      tid="amenityNotes-error"
                      id="amenityNotes-error">
                        {{ data.payerNotesError }}
                    </span>
            </div>
        </div>
        <div class="hoa-dialog__footer">
            <button name="cancel"
                    id="cancel"
                    tid="cancel"
                    type="button"
                    class="Button Button--link HOA-make-payment-button"
                    (click)="closeThisDialog({ save: false })">
                Cancel
            </button>
            <button class="Button Button--blue Button--minWidth130"
                    (click)="closeThisDialog({ save: true, text: data.payerNotes })"
                    [disabled]="data.payerNotesError">
                Continue
            </button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;